import { useMatch as reachUseMatch } from '@reach/router';
import useBasePath from '#/shared/hooks/useBasePath';
import { castDigitsToInt } from '#/shared/utils/string';

/**
 * An extension of the `useMatch` hook from @reach/router that incorporates
 * the basepath the application is using and allow for matching against
 * multiple routes
 *
 * @param {RouteInfo|RouteInfo[]} routes Single or array of route objects
 * containing the path(s) to match to the current location of the app
 * @param {Boolean} castDigitsToInt If `true` values for route params that are
 * of type string and consist only of digits will be converted to integer
 * @returns {Object|null} If a match is made an object containing the
 * information pertaining to url location, including route params, otherwise
 * `null`
 */
const useMatch = (
  routes,
  {
    // TODO: when this function is ported to TypeScript remove the default
    //  value for `castDigitsToInt` so an explicit value must be passed
    //  requiring the dev makes a deliberate decison on that setting
    castDigitsToInt: castDigitsToIntParam = false,
  } = {}
) => {
  const basePath = useBasePath();
  const routesArray = Array.isArray(routes) ? routes : [routes];

  const matchObject =
    routesArray.map(r => reachUseMatch(basePath + r.path)).find(r => !!r) ||
    null;

  if (matchObject && castDigitsToIntParam) {
    Object.entries(matchObject).forEach(([key, value]) => {
      matchObject[key] = castDigitsToInt(value);
    });
  }

  return matchObject;
};

export default useMatch;
